module.exports = __webpack_public_path__ + "assets-cabinet/img/dropdown-toggle.f96482aa.svg";